/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps, Theme } from '@mui/material';

export const skuBoxSx: SxProps<Theme> = (theme) => ({
	color: theme.palette.grey[200],
	marginBottom: '5px',
	textAlign: 'left',
	fontSize: '12px',
});
